import styled from 'styled-components';

import { token } from '@zillow/constellation';

export const StyledContainer = styled.div`
    background-color: ${token('colors.gray100')};
`;
